export class HeaderValue {

    constructor(public readonly header: string,
                public readonly value: string) {
    }
}
